<template>
  <div>
    <div class="mb20">
      <el-button type="primary" size="small" @click="importCad">新增</el-button>
    </div>
    <el-table class="global-table" stripe :data="versionList" v-loading="loading">
      <el-table-column label="图纸版本" prop="version" minWidth="120px" show-overflow-tooltip></el-table-column>
      <el-table-column label="上传日期" prop="uploadname" minWidth="120px" show-overflow-tooltip></el-table-column>
      <el-table-column label="文件名称" prop="filename" minWidth="120px" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" minWidth="120px" fixed="right">
        <template v-slot="{ row, $index }">
          <el-button type="text" @click="onDetail($index)">查看</el-button>
          <!-- <el-button type="text" @click="onDelete(row.version)">删除</el-button> -->
          <el-button type="text" @click="downloadDWG(row.filename)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { vjEnv } from '@/utils/config'
export default {
  name: 'CadList',
  data() {
    return {
      loading: false,
      versionList: []
    }
  },
  computed: {
    projectId() {
      return this.$route.query.projectId
    },
    currentProject() {
      return this.$store.state.projectList.find(item => item.projectId === this.projectId)
    },
    cadId() {
      return this.currentProject.cadId
    }
  },
  watch: {
  },
  created() {
    this.initService()
    if (this.cadId) {
      this.loadVersion()
    }
  },
  methods: {
    importCad() {
      // this.$store.commit('setProjectId', this.projectId)
      this.$router.push('/importCad?import=1&projectId=' + this.projectId)
    },
    onDetail(index) {
      this.$router.push('/measure?cadId=' + this.cadId + '&versionIndex=' + index)
    },
    downloadDWG(filename) {
      location.href = `${location.origin}/_download_dwg_${vjEnv.workspace}/${filename}?token=${vjEnv.accessToken}`
    },
    initService() {
      const svc = new vjmap.Service(vjEnv.serviceUrl, vjEnv.accessToken)
      this._svc = svc
      this._svc.switchWorkspace(vjEnv.workspace)
    },
    async loadVersion() {
      const data = await this._svc.listMaps(this.cadId, '*')
      if (data && data.length) {
        this.versionList = data.reverse()
      } else {
        this.versionList = []
      }
    },
    async onDelete(version) {
      this.$confirm('确认删除该版本, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await this._svc.cmdDeleteMap(this.cadId, version)
        console.log('data', data)
        if (data.status) {
          this.$message({ type: 'success', message: '删除成功' })
          this.loadVersion()
        } else {
          this.$message({ type:'error', message: '删除失败' })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
